import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Input from "./components/Input";
import Button from "../../components/Button";
import Geolocation from "../../components/Geolocation";
import Container from "../../components/Container";
import { locationSelector } from "../../services/location/reducer";
import {
  setLocationQuery,
  findLocation,
  setCurrentLocation,
  getSuggestions,
  clearSuggestions
} from "../../services/location/actions";
import iconLocate from "./assets/locate.svg";
import "./style.css";

class Location extends Component {
  state = {
    error: undefined
  };

  onChange = (event, { newValue }) => {
    this.setState({ error: undefined });
    this.props.setLocationQuery(newValue);
  };

  onReset = () => {
    this.props.setLocationQuery("");
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.props.getSuggestions(value);
  };

  onSuggestionsClearRequested = () => {
    this.props.clearSuggestions();
  };

  handleError = error => {
    this.setState({ error });
  };

  handleSubmit = () => {
    if (this.props.currentLocation !== "") {
      this.props.setCurrentLocation(this.props.currentLocation);
    }
  };

  render() {
    const {
      suggestions,
      isDone,
      locationDetails,
      currentLocation,
      findLocation
    } = this.props;

    return (
      <Container className="location">
        <div className="location__inner">
          <p>
            Jongeren zijn met minder en stemmen minder. Hoe groot is hun invloed
            echt? Vul je gemeente in en kom erachter hoeveel jouw stem waard is.
          </p>
          <div className="location__finder">
            <Input
              handleSubmit={this.handleSubmit}
              suggestions={suggestions}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
              placeholder="Zoek je gemeente"
              value={currentLocation}
              onChange={this.onChange}
              onClick={this.onReset}
            />

            <Geolocation
              onComplete={findLocation}
              onError={this.handleError}
              renderLoading={<div className="location__loading">Laden...</div>}
              renderTrigger={action => (
                <button className="location__locator" onClick={action}>
                  <img
                    src={iconLocate}
                    alt="Gebruik je huidige locatie"
                    width="24"
                    height="24"
                  />
                </button>
              )}
            />
          </div>
          {this.state.error && <p>{this.state.error}</p>}

          <div className="location__start">
            {!isDone && (
              <div className="location__center">
                <Button onClick={this.handleSubmit}>Start</Button>
              </div>
            )}
            {isDone && (
              <Fragment>
                {locationDetails === undefined && (
                  <div className="notification">
                    <p>
                      Niet gevonden... Alleen gemeentes die op 21 maart 2018
                      meedoen aan de gemeenteraadsverkiezingen zijn meegenomen.
                    </p>
                  </div>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </Container>
    );
  }
}

export default connect(locationSelector, {
  setCurrentLocation,
  setLocationQuery,
  getSuggestions,
  clearSuggestions,
  findLocation
})(Location);



// WEBPACK FOOTER //
// ./src/scenes/Location/index.js